import axios from 'axios';
import qs from 'qs';

import { fetchCsvAsBlob } from 'utils/export/csv';

export default class SiteServices {
  static async getSites({ params, model, modelId }, { signal } = {}) {
    let query = {
      model: 'Site',
      queries: [{ field: 'deleted_at', operator: '=', value: null }],
    };

    if (model) {
      query = {
        model: 'Site',
        queries: [
          {
            field: `${model}_id`,
            value: modelId,
          },
        ],
      };
    }

    const response = await axios.post('v2/search', query, { params, signal });
    return response.data;
  }

  static async getSitesQuery({ params, query }, { signal } = {}) {
    const response = await axios.post('v2/search', query, { params, signal });
    return response.data;
  }

  static async getSite(id) {
    return (await axios.get(`site/${id}/info`)).data;
  }

  static async createSite(data) {
    const response = await axios.post('sites/store', data);
    return response.data;
  }

  static async getOverview(params, clientId) {
    const query = {
      model: 'Site',
      queries: [
        {
          field: 'client_id',
          value: clientId,
        },
      ],
    };

    const response = await axios.post('sites/overview', query, {
      params,
      paramsSerializer: (queryParams) => qs.stringify(queryParams),
    });
    return response.data;
  }

  static async exportCsv(params) {
    return fetchCsvAsBlob('sites/export', params);
  }

  static async updateSite(id, data) {
    const response = await axios.put(`site/${id}`, {
      data,
    });
    return response.data;
  }

  static async deleteSite(id) {
    const response = await axios.delete(`site/${id}`);
    return response.data;
  }

  static async getSitesByFilter(filters, perPage = null, pageNumber = null) {
    const response = await axios.post('site/getByFilterV2', {
      per_page: perPage,
      page: pageNumber,
      ...{ filters },
    });
    return response.data;
  }

  static async getSiteNames() {
    const response = await axios.get('sites/names');
    return response.data;
  }

  static async getWhBillerSiteNames() {
    const response = await axios.get('client/billing/sites');
    return response.data;
  }

  // eslint-disable-next-line camelcase
  static async updateIsTaxExempt(id, is_tax_exempt) {
    const response = await axios.put(`site/${id}/is-tax-exempt`, {
      is_tax_exempt,
    });
    return response.data;
  }

  static async siteDetach(id, body) {
    const response = await axios.post(`site/${id}/detach`, body);
    return response.data;
  }

  static async getSiteExistence(locationInfo) {
    const response = await axios.get('site/exists', { params: locationInfo });
    return response.data;
  }
}
